import { ProjectIntegrationId, ProjectIntegrationsMap } from "@services/integrations-service/integrations-service-types";
import { isAutodeskLegacyProjectIntegration, isProcoreLegacyProjectIntegration, isProjectIntegration } from "@services/integrations-service/integrations-type-guards";

/**
 * @returns Whether a project is connected to Autodesk based on the given project integrations map
 * @param projectIntegrationsMap Project integrations map
 */
export function isProjectConnectedToAutodesk(
  projectIntegrationsMap: ProjectIntegrationsMap | undefined
): boolean {
  if (!projectIntegrationsMap) {
    return false;
  }

  const isAutodeskLegacyConnected = isAutodeskLegacyProjectIntegration(
    projectIntegrationsMap[ProjectIntegrationId.autodesk]
  );
  const isAutodeskAccIssuesConnected = isProjectIntegration(
    projectIntegrationsMap[ProjectIntegrationId.autodeskAccIssues]
  );
  const isAutodeskAccRfisConnected = isProjectIntegration(
    projectIntegrationsMap[ProjectIntegrationId.autodeskAccRfis]
  );
  const isAutodeskBim360IssuesConnected = isProjectIntegration(
    projectIntegrationsMap[ProjectIntegrationId.autodeskBim360Issues]
  );
  const isAutodeskBim360RfisConnected = isProjectIntegration(
    projectIntegrationsMap[ProjectIntegrationId.autodeskBim360Rfis]
  );

  return (
    isAutodeskLegacyConnected &&
    ((isAutodeskAccIssuesConnected && isAutodeskAccRfisConnected) ||
      (isAutodeskBim360IssuesConnected && isAutodeskBim360RfisConnected))
  );
}

/**
 * @returns Whether a project is connected to Procore based on the given project integrations map
 * @param projectIntegrationsMap Project integrations map
 */
export function isProjectConnectedToProcore(
  projectIntegrationsMap: ProjectIntegrationsMap | undefined
): boolean {
  if (!projectIntegrationsMap) {
    return false;
  }

  const isProcoreLegacyConnected = isProcoreLegacyProjectIntegration(
    projectIntegrationsMap[ProjectIntegrationId.procore]
  );
  const isProcoreObservationsConnected = isProjectIntegration(
    projectIntegrationsMap[ProjectIntegrationId.procoreObservations]
  );
  const isProcoreRfisConnected = isProjectIntegration(
    projectIntegrationsMap[ProjectIntegrationId.procoreRfis]
  );

  return (
    isProcoreLegacyConnected &&
    isProcoreObservationsConnected &&
    isProcoreRfisConnected
  );
}
